
































































































































































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import toml from 'toml';
import PrismEditor from 'vue-prism-editor';

import {Notify} from '@/utils/Notify';

import {LoraForwarderChirpStackConfig} from '@/model/lora/ChirpStackGatewayBridge/LoraForwarderChirpStackConfig';
import {LoraForwarderGatewayConfiguration} from '@/model/lora/UdpPacketForwarder/LoraForwarderUdpConfig';

import {ILoraForwarderChirpStackService} from '@/services/lora/forwarder/ILoraForwarderChirpStackService.service';

import LoraForwarderChirpStackStore from '@/store/lora/LoraForwarderChirpStack.store';

import LoraForwarderControl from '@/components/Lora/Forwarder/LoraForwarderControl.vue';
import LoraForwarderConfiguration from '@/components/Lora/Forwarder/LoraForwarderConfiguration.vue';
import LoraForwarderConfigFileEditor from '@/components/Lora/Forwarder/LoraForwarderConfigFileEditor.vue';
import LoraForwarderLog from '@/components/Lora/Forwarder/LoraForwarderLog.vue';
import LoraForwarderStats from '@/components/Lora/Forwarder/LoraForwarderStats.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {
    LoraForwarderStats,
    LoraForwarderLog,
    LoraForwarderControl, LoraForwarderConfiguration, LoraForwarderConfigFileEditor, PrismEditor,
  },
})
export default class LoraForwarderChirpStackSettings extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ILoraForwarderChirpStackService'))
  private loraForwarderChirpStackService!: ILoraForwarderChirpStackService;

  private forwarderStore: LoraForwarderChirpStackStore = getModule(LoraForwarderChirpStackStore, this.$store);

  private bridgeConfig: LoraForwarderChirpStackConfig = {};
  private bridgeConfigFile: string = '';
  private bridgeConfigEditor = false;

  private forwarderConfig: LoraForwarderGatewayConfiguration | any = {};
  private forwarderConfigEditor = false;

  private async mounted() {
    await this.refreshConfig();
    this.setLoaded();
  }

  private async refreshConfig() {

    await this.refreshBridgeConfigFile();

    try {
      this.bridgeConfig = new LoraForwarderChirpStackConfig(toml.parse(this.bridgeConfigFile));
      this.logger.debug(`Bridge config`, this.bridgeConfig);

    } catch (error) {
      Notify.Error(this.logger, `Could not get bridge configuration`, error);
    }

    try {
      this.forwarderConfig = await this.loraForwarderChirpStackService.getForwarderConfig();
      this.logger.debug(`Forwarder config`, this.forwarderConfig);

    } catch (error) {
      Notify.Error(this.logger, `Could not get forwarder configuration`, error);
    }
  }

  private async refreshBridgeConfigFile() {

    try {
      this.bridgeConfigFile = await this.loraForwarderChirpStackService.getBridgeConfigFile();

    } catch (error) {
      Notify.Error(this.logger, `Could not get bridge configuration file`, error);
    }
  }

  private async saveConfigFile() {
    try {

      try {
        toml.parse(this.bridgeConfigFile);
      } catch (error) {
        Notify.Error(this.logger, `The configuration file is no valid TOML`, error);
        return;
      }

      await this.loraForwarderChirpStackService.setBridgeConfigFile(this.bridgeConfigFile);
      Notify.Info(this.logger, `The new config has been saved, please restart the bridge to make it effective`);

      await this.refreshConfig();

    } catch (error) {
      Notify.Error(this.logger, `Could not save configuration file`, error);
    }
  }


  private async forwarderConfigClose() {
    this.forwarderConfigEditor = false;
    this.refreshConfig();
  }
}

